import type { Router } from "@/typeDefinitions/custom/Router";

const router: Router.LicensedRouterExportType = [
  {
    path: "/administration/keycloak/users/notRegistered",
    meta: {
      rights: ["user.admin"],
    },
    name: "KeycloakUserListNotRegistered",
    component: () => import("./views/KeycloakUserList.vue"),
  },
  {
    path: "/administration/keycloak/users/create/:id",
    meta: {
      rights: ["user.admin"],
    },
    name: "KeycloakUserCreate",
    component: () => import("./views/KeycloakUserCreate.vue"),
  },
];

export default router;
